import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28 2H4a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2zm0 25.5a.5.5 0 01-.5.5h-23a.5.5 0 01-.5-.5v-23a.5.5 0 01.5-.5h23a.5.5 0 01.5.5z"/><path d="M16 8a8 8 0 11-8 8 8 8 0 018-8m0-2a10 10 0 1010 10A10 10 0 0016 6z"/><path d="M21.83 16.45a1 1 0 00-1.38-.28 2.35 2.35 0 01-3-.08 4.36 4.36 0 00.41-5.64 1 1 0 00-1.66 1.1 2.35 2.35 0 01-.08 3 4.36 4.36 0 00-5.64-.41 1 1 0 101.1 1.66 2.35 2.35 0 013 .08 4.36 4.36 0 00-.41 5.64A1 1 0 0015 22a.94.94 0 00.55-.17 1 1 0 00.28-1.38 2.33 2.33 0 01.09-3 4.54 4.54 0 003 1.26 4.65 4.65 0 002.59-.85 1 1 0 00.32-1.41zM16 17a1 1 0 111-1 1 1 0 01-1 1z"/>';
export var AirConditioningOutlineSVG = function AirConditioningOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
AirConditioningOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(AirConditioningOutlineSVG);